import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import page from '../views/page.vue'
import layout from '../views/layout/index.vue'
import f10Index from '../views/f10/index.vue'
import f10IndexHk from '../views/f10Hk/index.vue'
import f10IndexUs from '../views/f10Us/index.vue'
import upAnalysis from '../views/upAnalysis.vue'
import hot from '../views/hot.vue'
import store from '@/store'

const routesarr = [
  // {
  //   // 操作手册
  //   path: '/page',
  //   name: 'name',
  //   redirect: '/home'
  // },
  // ---------------------此处操作手册路由必须为第0个，如修改了顺序，需要修改store里的FRESH_MYROUTES方法
  {
    // 操作手册
    path: '/page',
    name: 'Layout',
    component: layout,
    children: [
    ]
  },
  {
    path: '/f10',
    name: 'f10laout',
    component: f10Index
  },
  {
    path: '/f10Hk',
    name: 'f10laout-hk',
    component: f10IndexHk
  },
  {
    path: '/f10Us',
    name: 'f10laout-Us',
    component: f10IndexUs
  },
  {
    path: '/hot',
    name: 'hot',
    component: hot
  },
  {
    path: '/lowversion',
    name: 'lowversion',
    component: () => import(/* webpackChunkName: "lowversion" */ '../views/lowversion.vue')
  },
  {
    // 涨停分析
    path: '/upAnalysis',
    name: 'upAnalysis',
    component: upAnalysis
  },
  {
    // 问董秘
    path: '/asking',
    name: 'asking',
    component: () => import(/* webpackChunkName: "asking" */ '../views/asking/index.vue')
  },
  {
    path: '/askingdetail',
    name: 'askingdetail',
    component: () => import(/* webpackChunkName: "askingdetail" */ '../views/asking/detail.vue')
  },
  {
    path: '/askingdelist',
    name: 'askingdelist',
    component: () => import(/* webpackChunkName: "askingdetail" */ '../views/asking/list.vue')
  },
  {
    path: '/top10',
    name: 'top10',
    component: () => import(/* webpackChunkName: "top10" */ '../components/asktheSecretary/top10.vue')
  },
  {
    // 股池 (已废弃)
    path: '/stockpool',
    name: 'stockpool',
    component: () => import(/* webpackChunkName: "stockpool" */ '../views/stockpool/index.vue')
  },
  {
    path: '/smallAmount',
    name: 'smallAmount',
    component: () => import(/* webpackChunkName: "smallAmount" */ '../views/smallAmount/index.vue')
  },
  {
    // 九方学堂
    path: '/school',
    name: 'jfschool',
    component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
    children: [
      {
        path: '/excellentcourse',
        name: 'excellentcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/excellentcourse.vue'),
        meta: {
          title: '精品课程'
        }
      },
      {
        path: '/selectedtopics',
        name: 'selectedtopics',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/selectedtopics.vue'),
        meta: {
          title: '精选专题',
          hide: true,
        }
      },
      {
        path: '/specialcourse',
        name: 'specialcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/specialcourse.vue'),
        meta: {
          title: '专题课程',
          hide: true,
          pname: 'selectedtopics'
        }
      },
      {
        path: '/allcourse',
        name: 'allcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/allcourse.vue'),
        meta: {
          title: '全部课程'
        }
      },
      {
        path: '/coursedetail',
        name: 'coursedetail',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/coursedetail.vue'),
        meta: {
          title: '课程详情',
          hide: true,
          pname: 'excellentcourse'
        }
      },
      {
        path: '/subjectdetail',
        name: 'subjectdetail',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/subjectdetail.vue'),
        meta: {
          title: '专题详情',
          hide: true,
          pname: 'excellentcourse'
        }
      },
      {
        path: '/articledetail',
        name: 'articledetail',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/articleDetail.vue'),
        meta: {
          title: '文章详情',
          hide: true,
          pname: 'excellentcourse'
        }
      }
    ]
  },
  {
    path: '/tokenpage',
    name: 'tokenpage',
    component: () => import(/* webpackChunkName: "test" */ '../views/test/tokenrequest.vue')
  },
  // 个股笔记
  {
    path: '/stocknotes/index',
    name: 'stocknotes',
    component: () => import(/* webpackChunkName: "stocknotes" */ '../views/stocknotes/index.vue')
  },
  {
    path: '/stocknotes/kline',
    name: 'klinenotes',
    component: () => import(/* webpackChunkName: "stocknotes" */ '../views/stocknotes/kline.vue')
  },
  // 条件选股
  {
    path: '/conditionstock',
    name: 'conditionstock',
    component: () => import(/* webpackChunkName: "conditionstock" */ '../views/conditionstock/index.vue')
  },
  {
    path: '/pageAll',
    name: 'pageAll',
    component: () => import(/* webpackChunkName: "pageAll" */ '../views/pageAll/index.vue')

  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/chat/Chat.vue')
  },
  {
    path: '/new-chat',
    name: 'newChat',
    component: () => import(/* webpackChunkName: "newChat" */ '../views/chat/NewChat.vue')
  },
  {
    path: '/chipSituation',
    name: 'chipSituation',
    component: () => import(/* webpackChunkName: "chipSituation" */ '../views/chipSituation/index.vue')
  },
  // 方舟一号
  {
    path: '/arkone',
    name: 'arkone',
    component: () => import(/* webpackChunkName: "arkone" */ '../views/arkOne/index.vue')
  },
  // Star 星选
  {
    path: '/star',
    name: 'star',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/index.vue')
  },
  //回测记录
  {
    path: '/star/result',
    name: 'starResult',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/result.vue')
  },
  //我的消息
  {
    path: '/star/message',
    name: 'starMessage',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/message.vue')
  },
  // Star - 个股量化
  {
    path: '/star/stock',
    name: 'starStock',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/stock/index.vue')
  },
  //个股量化的回测结果(包括ai回测结果，还有对应的策略详情（策略详情就是右侧多一个小模块）；)
  {
    path: '/star/stock/result',
    name: 'starStockResult',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/stock/result.vue')
  },
  // Star - 策略口令、组合量化
  {
    path: '/star/group',
    name: 'starGroup',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/group/index.vue')
  },
  //组合量化的回测结果（包括口令粘贴的回测结果，还有对应的策略详情）
  {
    path: '/star/group/result',
    name: 'starGroupResult',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/group/result.vue')
  },
  // Star - 学习圈
  {
    path: '/star/quant',
    name: 'starQuant',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/quant.vue')
  },
  // Star - 量化专区
  {
    path: '/star/zone',
    name: 'starZone',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/zone/index.vue')
  },
  // Star - 模版策略
  {
    path: '/star/square',
    name: 'starSquare',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/square/index.vue')
  },
  {
    path: '/star/square/result',
    name: 'starSquareResult',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/square/result.vue')
  },
  // Star - 热门专题
  {
    path: '/star/hot-subject',
    name: 'starHotSubject',
    component: () => import(/* webpackChunkName: "star" */ '../views/star/hotSubject/index.vue')
  },
  {
    path: '/star/hot-subject/detail',
    redirect: (to) => ({
      path: '/star/hot-subject',
      query: to.query,
    }),
  },
  // 情绪风向标
  {
    path: '/sentiment/trend',
    name: 'sentimentTrend',
    component: () =>
      import(/* webpackChunkName: "sentiment" */ '../views/sentiment/trend.vue')
  },
  {
    path: '/sentiment/capital-flow',
    name: 'sentimentCapitalFlow',
    component: () =>
      import(/* webpackChunkName: "sentiment" */ '../views/sentiment/capital-flow.vue')
  },
  {
    path: '/sentiment/sector-strength',
    name: 'sentimentSectorStrength',
    component: () =>
      import(/* webpackChunkName: "sentiment" */ '../views/sentiment/sector-strength.vue')
  },
  // 个股龙头表现
  {
    path: '/dragonHunterDetail',
    name: 'dragonHunterDetail',
    component: () => import(/* webpackChunkName: "dragonHunterDetail" */ '../views/dragonHunterDetail/index.vue')
  },
  // 资讯详情独立页（通过 ?selectedId=xxx 直接展示详情）
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsDetailPage.vue')
  },
  // 资讯
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/news/index.vue'),
    redirect: '/news/overview',
    children: [
      { path: 'overview',  name: 'news-overview',  component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Overview.vue') },
      { path: 'optional',  name: 'news-optional',  component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Optional.vue') },
      { path: 'live',      name: 'news-live',      component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Live.vue') },
      { path: 'important', name: 'news-important', component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Important.vue') },
      { path: 'zhiyan',    name: 'news-zhiyan',    component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Zhiyan.vue') },
      { path: 'ipo',       name: 'news-ipo',       component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Ipo.vue') },
      { path: 'crypto',    name: 'news-crypto',    component: () => import(/* webpackChunkName: "news" */ '../views/news/tabs/Crypto.vue') },
  // 策略
    ]
  },
  // {
  //   path: '/strategy',
  //   name: 'strategy',
  //   component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/index.vue'),
  //   redirect: { name: 'strategySubscription' },
  //   children: [
  //     {
  //       // 固定路由：我的订阅
  //       path: 'subscription',
  //       name: 'strategySubscription',
  //       component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/components/SubscriptionView.vue')
  //     },
  //     {
  //       // 动态路由：各分类（量化策略/名人持仓/热门概念/方德精选等）
  //       path: 'category/:category',
  //       name: 'strategyCategory',
  //       component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/components/CategoryView.vue')
  //     }
  //   ]
  // }
  // 策略
  {
    path: '/strategy',
    name: 'strategy',
    component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/index.vue'),
    redirect: { name: 'strategySubscription' },
    children: [
      {
        // 固定路由：我的订阅
        path: 'subscription',
        name: 'strategySubscription',
        component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/components/SubscriptionView.vue')
      },
      {
        // 动态路由：各分类（量化策略/名人持仓/热门概念/方德精选等）
        path: 'category/:category',
        name: 'strategyCategory',
        component: () => import(/* webpackChunkName: "strategy" */ '../views/strategy/components/CategoryView.vue')
      }
    ]
  }
]
// const operationroutes = sessionStorage.getItem('operationroutes') ? JSON.parse(sessionStorage.getItem('operationroutes') || '[]') : []

// if (operationroutes && operationroutes.length) {
//   routesarr[1].children = JSON.parse(sessionStorage.getItem('operationroutes') || '[]')
// }
const operationroutes: any = store.state.myroutes
// const operationroutes: any = JSON.parse(localStorage.getItem('vuex') || '{}').myroutes
if (operationroutes.length) {
  routesarr[1].children = operationroutes
}
const routes: Array<any> = routesarr

let router = createRouter({
  history: createWebHashHistory(),
  routes
})
if ((location.href).indexOf('routingmode=history') > -1) {
  router = createRouter({
    history: createWebHistory(),
    routes
  })
}
export default router
